import { ApplicationConfig } from '@angular/core';

import { provideRouter, withRouterConfig } from '@angular/router';
import { routes } from './app.routes';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { provideToastr } from 'ngx-toastr';
import { provideAnimations } from '@angular/platform-browser/animations';
import { provideNativeDateAdapter } from '@angular/material/core';

import { provideAuth0 } from '@auth0/auth0-angular';
import { auth0WrapperConfig, authConfig, supportLibConfig } from './modules/auth/auth0.config';
import { AUTH0_WRAPPER_CONFIG, authInterceptor } from '@auth/bp-pf-auth';
import { provideBpTheme } from '@support/bp-pf-theme';
import { provideNotificationClient } from '@notification/bp-pf-notification';
import { environment } from '../environments/environment';
import { authErrorInterceptor } from './interceptors/auth-error.interceptor';
import { editLockInterceptor } from './interceptors/edit-lock.interceptor';

import { SUPPORT_LIB_CONFIG } from '@support/bp-pf-support';

export const appConfig: ApplicationConfig = {
  // A rejected Back/Forward navigation must restore the original history position.
  providers: [provideRouter(routes, withRouterConfig({ canceledNavigationResolution: 'computed' })),
  provideToastr(),
   provideHttpClient(withInterceptors([authInterceptor, editLockInterceptor]), withFetch()),
   provideAnimations(), provideNativeDateAdapter(),
      provideAuth0(authConfig.Auth0Data),provideBpTheme('gsrs'),
    { provide: AUTH0_WRAPPER_CONFIG, useValue: auth0WrapperConfig },
    { provide: SUPPORT_LIB_CONFIG, useValue: supportLibConfig },
      provideNotificationClient({
        notificationUrl: environment.notificationUrl
  })
  ]
};
